import type { NextPage } from "next"
import { useEffect, useState } from "react"
// import { formatDate } from "src/utils"
// import { Container } from "src/layout/container/Container"
// import ModuleList from "src/components/module-list/ModuleList"
// import BlogPostGridModule, { TextGridItem } from "src/modules/text-grid-module/BlogPostGridModule"
// import RichText from "src/components/rich-text/RichText"
// import cn from "classnames"
// import s from "./blogPost.module.scss"
import { useOverwrites } from "../../layout/page/overwriteContext"
// import FullscreenImageModule from "../../modules/fullscreen-image-module/FullscreenImageModule"
// import PositiveAngle from "src/components/positive-angle/PositiveAngle"
import { Container } from "src/layout/container/Container"
import { BaseQueryProps } from ".."
import BlogPostGridModule from "src/modules/blog-post-grid-module/BlogPostGridModule"
import { getUrlForNextPageInBlogOverview, TeaserBlogPost } from "./blogHelper"
import s from "./blogOverview.module.scss"
import cn from "classnames"
import { useSettings } from "src/layout/page/settingsContext"
import { getTranslation } from "src/lib/translations"
import { Button } from "src/components/button/Button"
import { Only } from "src/utils"
import { useRouter } from "next/router"
import Config from "src/Config"
import CollageModule from "src/modules/collage-module/CollageModule"
import { stringToRichText } from "src/utils"

export interface BlogOverviewDocument extends BaseQueryProps {
    blogPosts: TeaserBlogPost[]
    categories: TeaserBlogPost["category"][]
}

const Template: NextPage<{ pageData: BlogOverviewDocument }> = ({ pageData }) => {
    const { lang, segment } = useSettings()
    const { asPath } = useRouter()
    const t = getTranslation("blog", lang)
    const { headerDownloadCTA: headerDownloadLink } = useOverwrites()
    const [blogPosts, setBlogPosts] = useState(pageData.blogPosts.slice(0, 15))
    const [hasAnotherPageOfBlogPosts, setHasAnotherPageOfBlogPosts] = useState(pageData.blogPosts.length > 15)
    const [activeCategory, setActiveCategory] = useState(null)
    const [isFetchingMoreBlogPosts, setIsFetchingMoreBlogPosts] = useState(false)
    const allCategoriesSelection = { title: t.showAllCategories, _id: null, slug: null, englishTitle: null }
    const categories: TeaserBlogPost["category"][] = [allCategoriesSelection, ...pageData.categories]

    const nextPagePath = getUrlForNextPageInBlogOverview((Config.BASE_URL + "/" + lang + asPath))

    useEffect(() => {
        // Get active category from url
        if (typeof window !== "undefined") {
            const paths = location.pathname.split("/")
            const category = paths.slice(4, 5)[0]
            const categoryFromPath = category && categories.find((c) => c.slug === category)
            if (categoryFromPath) {
                setActiveCategory(categoryFromPath)
            }
        }
    }, [])

    useEffect(() => {
        if (activeCategory) {
            loadMoreBlogPosts(true)
        }
    }, [activeCategory])


    useEffect(() => {
        if (pageData.headerCTAOverwrite?.style) {
            headerDownloadLink.setCTA(pageData.headerCTAOverwrite)
        }
    }, [headerDownloadLink, pageData.headerCTAOverwrite])


    // const heroImage: SanityImage = {
    //     type: "image",
    //     src: "https://cdn.sanity.io/images/inp43svr/production/7515d0add1f52a7e99e8337df89f5da1f602f57a-667x1000.jpg",
    //     placeholder: null,
    //     alt: null,
    //     width: 667,
    //     height: 1000,
    // }

    async function loadMoreBlogPosts(clearExistingBlogPosts = false) {
        if (isFetchingMoreBlogPosts) return
        setIsFetchingMoreBlogPosts(true)

        let existingBlogPosts, lastPublishedAt
        if (clearExistingBlogPosts) {
            existingBlogPosts = []
            lastPublishedAt = null
        } else {
            existingBlogPosts = blogPosts
            lastPublishedAt = blogPosts.length > 0 ? blogPosts?.slice(-1)[0]?.publishedAt : null
        }

        const res = await fetch(`/api/blogPosts?` + new URLSearchParams({
            locale: lang,
            segment,
            ...(lastPublishedAt ? { lastPublishedAt } : {}),
            ...(activeCategory?._id ? { category: activeCategory._id } : {}),
        }))
        const newBlogPosts = await res.json() as TeaserBlogPost[]
        setIsFetchingMoreBlogPosts(false)
        setBlogPosts([...existingBlogPosts, ...newBlogPosts.slice(0, 15)])
        setHasAnotherPageOfBlogPosts(newBlogPosts.length > 15)
    }

    return (
        <div className={cn(s["blog-overview"])}>
            {/* <HeroCollageModule largeTitle={t.overviewHeadline} media={heroImage} smallTitle={t.overviewSubtitle} shapeColor="sky" /> */}
            <CollageModule backgroundColor={segment === "private" ? "fog" : "black"} boxFormat="small" box1={{ title: { text: stringToRichText(t.overviewHeadline), lightFontWeight: true, size: "heading-200" }, bodyText: { text: stringToRichText(segment === "private" ? t.overviewSubtitle : t.overviewSubtitleBusiness) } }} box2={{}} moduleIndex={0} />
            <Container className={cn(s["blog-overview__categories"])}>
                <h2 className={cn(s["blog-grid-module__item__title"], "heading-200")} >{t.categories}</h2>

                {categories.map((category) => (
                    <span onClick={() => setActiveCategory(category)} className={cn("label-200", { [s["blog-overview__categories__active"]]: activeCategory?._id === category._id })} key={category._id}>{category.title}</span>
                ))}
            </Container>
            <BlogPostGridModule blogPosts={blogPosts} columns={3} showOnlyCategory={activeCategory ? activeCategory.slug : null} />
            <Container className={cn(s["blog-overview__button-container"])}>
                <Only if={hasAnotherPageOfBlogPosts}>
                    {/* a tag for SEO purposes */}
                    <a onClick={(e) => e.preventDefault()} rel="next" href={nextPagePath}>
                        <Button pill onClick={() => loadMoreBlogPosts(false)} disabled={isFetchingMoreBlogPosts} center className={cn("label-200", { [s["blog-overview__load-button--loading"]]: isFetchingMoreBlogPosts })} >{t.loadNextPage}</Button>
                    </a>
                </Only>
            </Container>
        </div>
    )
}

export default Template
